import React from 'react';
const Music = () => {
  return (
    <div className="music-player">
      <iframe 
        src={"/website/index.html"}
        width="100%"
        height="100%" 
        frameBorder="0" 
        allowtransparency="true" 
        allow="encrypted-media"
        title="Spotify Playlist">
      </iframe>
    </div>
  );
}

export default Music;